export const SERVICE_PUNCTURE_REPAIR = 1; // Ремонт прокола
export const SERVICE_PRE_INSURANCE_INSPECTION = 2; // Предстраховой осмотр
export const SERVICE_COLLECTION_OF_CERTIFICATES = 3; // Сбор справок ГИБДД
export const SERVICE_OPEN_DOOR = 4; // Вскрыть авто (дверь, капот)
export const SERVICE_TIRE_STORAGE_MOBILE = 5; // Хранение шин
export const SERVICE_BRING_FUEL = 7; // Подвезти топливо
export const SERVICE_REPLACE_WHEEL = 8; // Поставить запаску
export const SERVICE_FINES = 9; // Штрафы
export const SERVICE_AVARCOM = 11; // Вызвать аваркома
export const SERVICE_VZR = 12; // ВЗР
export const SERVICE_CALL_TOW_TRUCK = 13; // Вызвать эвакуатор
export const SERVICE_40_PROPERTY = 40; // Недвижимость
export const SERVICE_PREPARING_FOR_EVACUATION = 41; // Подготовить к эвакуации
export const SERVICE_CALL_MANIPULATOR_TRUCK = 42; // Вызвать манипулятор
export const SERVICE_START_ENGINE = 45; // Запустить двигатель
export const SERVICE_DRIVE_CAR = 49; // Перегнать авто
export const SERVICE_VEHICLE_REGISTRATION = 50; // Постановка на учёт в ГИБДД
export const SERVICE_TELEMATICS = 52; // Телематика
export const SERVICE_LOSS = 55; // Урегулирование убытков
export const SERVICE_61_EXPERT_APPOINTMENT = 61; // Запись к эксперту
export const SERVICE_65_DETAILING_CARWASH = 65; // детейлинг
export const SERVICE_68_TIRE_FITTING_STATIONARY = 68; // Стационарный шиномонтаж
export const SERVICE_69_TIRE_STORAGE_STATIONARY = 69; // Хранение шин
export const SERVICE_6_AIR_CONDITIONER_FILL = 6; // Заправка кондиционера